import GenericPopup from "@/shared-components/popups/components/GenericPopup";

import ImageCropper from "./ImageCropper";

import "./styles/PopupUpdateProfilePicture.css";

const PopupUpdateProfilePictureInSettings = ({ open, image, exitCrop, continueCrop, setCroppedFile, setCroppedUrl, cropShape }) => {
  // Define cropAreaClass inside the function
  const cropAreaClass = cropShape === 'circle' ? 'crop-circle' : 'crop-rect';

  return (
    <GenericPopup
      open={open}
      className={`profile-picture__crop-popup ${cropAreaClass}`}
    >
      <div className="profile-picture__header">
        <p className="profile-picture__header-text">
          Update Profile Picture
        </p>
        <p className="profile-picture__instructions">
          Adjust and crop your profile picture
        </p>
      </div>
      <ImageCropper
        source={image}
        width={200}
        height={200}
        cropShape={cropShape}
        exitCrop={exitCrop}
        continueCrop={continueCrop}
        setCroppedUrl={setCroppedUrl}
        setCroppedFile={setCroppedFile}
      />
    </GenericPopup>
  );
};

export default PopupUpdateProfilePictureInSettings;